<template>
  <div>
    <b-row class="no-gutters">
      <b-col>
        <h1 class="font-weight-bold header-main text-uppercase mb-3">
          รายละเอียด Batch ID ({{ detail.batchNo }})
        </h1>
      </b-col>
      <b-col class="text-right d-flex justify-content-end">
        <b-button variant="link" class="px-1 py-0">
          <router-link to="/batch?brandID=1">
            <u>ย้อนกลับ</u>
          </router-link>
        </b-button>
      </b-col>
    </b-row>
    <div class="mt-2">
      <BatchDetailPanel
        v-if="dataReady"
        v-on:openMoveOrder="openMoveOrder"
        :id="id"
        :detail="detail"
        ref="isBatchDetailPanel"
      />
      <DetailPanel v-if="dataReady" :details="detail.logWarehouseActivity" />
    </div>
    <MoveOrder v-on:openConfirmModal="openConfirmModal" :orderSelectArr="orderSelectArr" ref="moveOrderModal" />
    <ModalAlert
      :text="messageAlertModal"
      v-on:hadleModalAlertClose="hadleModalAlertClose"
      ref="isModalAlert"
    />
    <ModalAlertConfirm
      :msg="titleConfirmModal"
      :text="detailConfirmModal"
      btnConfirm="ตกลง"
      btnCancel="ยกเลิก"
      ref="isModalAlertConfirm"
      @confirm="acceptMoveOrder"
    />
    <ModalMoveToCreateBatch
      :orderSelectArr="orderSelectArr"
      :orderList="orderList"
      @getBatchDetail="getBatchDetail"
    />
  </div>
</template>
<script>
import BatchDetailPanel from "./components/batchDetail/BatchDetailPanal.vue";
import DetailPanel from "./components/detail/DetailPanel.vue";
import MoveOrder from "./components/modal/moveOrder.vue";
import ModalMoveToCreateBatch from "./components/modal/moveToCreate.vue";
import ModalAlert from "@/components/modal/alert/ModalAlert.vue";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm";

export default {
  name: "BatchDetails",
  components: {
    BatchDetailPanel,
    DetailPanel,
    MoveOrder,
    ModalAlert,
    ModalAlertConfirm,
    ModalMoveToCreateBatch,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
      dataReady: false,
      detail: {
        batchId: "",
        batchNo: "",
        batchStatus: "",
        countOrder: 0,
        countProduct: 0,
        dateOrder: "",
        logs: null,
        logWarehouseActivity: [],
        sellerShop: "",
        shipping: "",
        totalOrder: 0,
        totalProduct: 0,
        updatedTime: "",
      },
      orderList: [],
      orderSelectArr: [],
      countOrderMove: 0,
      batchIdMove: null,
      messageAlertModal: "",
      titleConfirmModal: "",
      detailConfirmModal: "",
    };
  },
  created() {
    this.getBatchDetail();
  },
  methods: {
    getBatchDetail() {
      this.dataReady = false;
      this.axios
        .get(`${this.$baseUrl}/Batch/Detail/${this.id}`)
        .then((data) => {
          this.detail = data.detail;
          this.dataReady = true;
        });
    },
    openMoveOrder(obj) {
      let { orderSelectList, orderSelectArr } = obj;

      this.orderList = orderSelectList;
      this.countOrderMove = orderSelectList.length;
      this.orderSelectArr = orderSelectArr;

      this.$refs.moveOrderModal.show();
    },
    openConfirmModal(batchId) {
      this.batchIdMove = batchId;
      this.titleConfirmModal = "ยืนยันการย้ายรายการคำสั่งซื้อ";
      this.detailConfirmModal = "ต้องการย้ายรายการคำสั่งซื้อหรือไม่";
      this.$refs.isModalAlertConfirm.show();
    },
    acceptMoveOrder() {
      this.dataReady = false;
      this.axios
        .post(`${this.$baseUrl}/Batch/MoveBatchByOrderId`, {
          OrderId: this.orderList,
          NewBatchId: this.batchIdMove[0],
        })
        .then((data) => {
          this.$refs.isModalAlertConfirm.hide();
          this.titleConfirmModal = "";
          this.detailConfirmModal = "";
          this.messageAlertModal = `ระบบทำการย้ายรายการคำสั่งซื้อทั้ง ${this.countOrderMove} รายการแล้วเรียบร้อย`;
          this.$refs.isModalAlert.show();
          this.dataReady = true;
          setTimeout(() => {
            this.$refs.isModalAlert.hide();
          }, 5000);
        });
    },
    hadleModalAlertClose() {
      this.messageAlertModal = "";
      this.orderList = [];
      this.countOrderMove = 0;
      this.batchIdMove = null;
      this.getBatchDetail();
      this.$refs.isBatchDetailPanel.getOrderList();
      this.$refs.isBatchDetailPanel.getProductList();
    },
  },
};
</script>

<style lang="scss" scoped></style>
